<mat-card class="menu">
    <ng-content></ng-content>
</mat-card>
